import { Product } from "./contracts/Product";
import { ProductVariant } from "~/use-cases/contracts/ProductVariant";
import { useAppContext } from "~/ui/app-context/provider";
import displayPriceFor from "~/use-cases/checkout/pricing";
import { State } from "~/ui/app-context/types";
import { buildLanguageMarketAwareLink } from "~/use-cases/LanguageAndMarket";

export const buildSchemaMarkup = (
  product: Product,
  selectedVariant: ProductVariant,
  baseUrl: string,
  state?: State,
) => {
  const price = displayPriceFor(
    selectedVariant,
    {
      default: "default",
      discounted: "sales",
    },
    state?.currency?.code || "NOK",
  );

  const hasMultipleVariants = product.variants.length > 1;
  const canonical = `${baseUrl}/${buildLanguageMarketAwareLink(product.path, "no")}${hasMultipleVariants ? `?sku=${selectedVariant?.sku}` : ""}`;

  return {
    "@context": "https://schema.org/",
    "@type": "Product",
    "@id": canonical,
    name: product.seo.title || selectedVariant?.name,
    image: product.seo.image || selectedVariant?.images[0]?.url,
    description: product.seo.description || selectedVariant?.description,
    sku: selectedVariant?.sku,
    offers: {
      "@type": "Offer",
      url: canonical,
      priceCurrency: state?.currency?.code,
      price:
        price.discounted && price.discounted < price.default
          ? price.discounted
          : price.default,
      itemCondition: "https://schema.org/NewCondition",
      availability:
        selectedVariant.outofstock.content?.value === true
          ? "https://schema.org/OutOfStock"
          : "https://schema.org/InStock",
    },
  };
};

export const buildSchemaMarkupForBlogPost = (data: any, url?: any) => {
  const title = data.seo.title;
  const description = data.seo.description;
  const altDescription = data.seo.description;

  return {
    "@context": "http://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "",
    },
    headline: title || data.name,
    datePublished: data.createdAt,
    dateModified: new Date(data.updatedAt),
    description: description || altDescription,
  };
};
